import styled, { createGlobalStyle } from "styled-components";
import { CommonButton } from "../../common-styles";

export const CreatorDetailsGlobalStyle = createGlobalStyle`
  .creator-details-content h1 {
    font-size: 2rem;
    line-height: 1.15;
  }

  .creator-details-content > .login-form,
  .creator-details-content form .login-form {
    gap: 1.35rem;
  }

  .creator-details-content form .login-form {
    margin-top: 0;
  }

  @media (max-width: 500px) {
    .creator-details-content h1 {
      font-size: 1.85rem;
      line-height: 1.15;
    }

    .creator-details-content > .login-form {
      margin-top: 1.35rem;
      gap: 1.5rem;
    }

    .creator-details-content form,
    .creator-details-content form .login-form {
      width: 100%;
    }

    .creator-details-content form .login-form {
      margin-top: 0;
      gap: 1.25rem;
    }
  }
`;

export const RequirementsBlock = styled.section`
  width: 100%;
`;

export const RequirementsHeading = styled.p`
  margin: 0 0 0.75rem;
  color: #fff;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;

  @media (max-width: 500px) {
    margin-bottom: 0.65rem;
    text-align: left;
    font-size: 17px;
    line-height: 1.35;
  }
`;

export const RequirementsList = styled.ul`
  margin: 0;
  padding-left: 1.2rem;
  color: rgba(255, 255, 255, 0.82);
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  list-style: disc outside;

  li {
    margin-bottom: 0.5rem;
    padding-left: 0.25rem;
  }

  li:last-child {
    margin-bottom: 0;
  }

  li::marker {
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.72em;
  }

  @media (max-width: 500px) {
    padding-left: 1.1rem;
    font-size: 15px;
    line-height: 1.45;

    li {
      margin-bottom: 0.42rem;
      padding-left: 0.18rem;
    }
  }
`;

export const FieldGroup = styled.div`
  width: 100%;
`;

export const SectionLabel = styled.p`
  display: block;
  margin: 0 0 0.75rem;
  background: transparent;
  background: linear-gradient(90deg, #2c94df 0%, rgba(255, 255, 255, 0.76) 100%);
  background-clip: text;
  color: transparent;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  span {
    color: inherit;
    -webkit-text-fill-color: transparent;
  }

  @media (max-width: 500px) {
    margin-bottom: 0.55rem;
    font-size: 17px;
    line-height: 1.35;
  }
`;

export const InputRow = styled.div`
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  gap: 0.6rem;

  @media (max-width: 500px) {
    min-height: 44px;

    input {
      height: 44px;
    }
  }

  svg {
    width: 18px;
    height: 18px;
    color: #fff;
  }
`;

export const ContactRow = styled.div`
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 500px) {
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 0.6rem;

    input {
      height: 44px;
    }
  }
`;

export const StaticPrefix = styled.span`
  color: #fff;
  font-size: 17px;
  line-height: 1;
`;

export const ContactSelector = styled.select`
  width: 100%;
  height: 2rem;
  border: 0;
  border-bottom: 1px solid #8f8f8f;
  border-radius: 0;
  background: #000;
  color: #fff;
  outline: none;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: 1.4;

  @media (max-width: 500px) {
    height: 44px;
    padding: 0 0.2rem;
  }
`;

export const ErrorText = styled.p`
  min-height: 18px;
  margin: 0.35rem 0 0 2.1rem;
  color: #ff7272;
  font-size: 13px;
  line-height: 1.35;

  @media (max-width: 500px) {
    &:empty {
      min-height: 0.4rem;
      margin: 0;
    }
  }
`;

export const SecurityNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.8rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.018);
  color: rgba(255, 255, 255, 0.48);
  font-size: 12px;
  line-height: 1.45;

  svg {
    flex-shrink: 0;
    margin-top: 1px;
    color: rgba(255, 255, 255, 0.42);
  }

  span {
    max-width: 100%;
    text-align: left;
  }
`;

export const CreatorContinueButton = styled(CommonButton)`
  @media (max-width: 500px) {
    min-height: 46px;
  }

  ${({ $isActive, disabled }) =>
    $isActive &&
    !disabled &&
    `
      background: linear-gradient(90deg, #0d6ac3 0%, #c87ae3 54%, #fd9101 100%);
      color: #ffffff;
    `}
`;
